export const PhoneNumberValidator = {
  methods: {
    ValidateSLOMobileNumber (msisdn) {
      let denisSuperRegex = new RegExp('^(?:\\+386|00386|386|0)(?:590\\d{5}|059\\d{6}|65(?:1\\d|55|[67]0)\\d{4}|[37][01]\\d{6}|4[0139]\\d{6}|51\\d{6}|6[489]\\d{6})$')
      return denisSuperRegex.test(msisdn)
    },
    ValidateSLOFixNumber (msisdn) {
      let regex = new RegExp('^(?:0|386)(\\d{8})$')
      return regex.test(msisdn)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/GlobalnoTelefonija/PhoneNumberValidator.js